// BannerSlider.js
import React from "react";
import { Button } from "react-bootstrap";

function BannerSlider({ slides }) {
  return (
    <div className="banner-slider rounded overflow-hidden  dashboardSlider">
      <div
        id="bannerCarousel"
        className="carousel slide border-0 p-0 mb-0"
        data-bs-ride="carousel"
      >
        {/* Indicators */}
        <div className="carousel-indicators">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              data-bs-target="#bannerCarousel"
              data-bs-slide-to={i}
              className={i === 0 ? "active" : ""}
            />
          ))}
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          {slides.map((slide, i) => (
            <div
              className={`carousel-item ${i === 0 ? "active" : ""}`}
              key={i}
            >
              <img
                src={slide.image}
                className="d-block w-100 slider-img"
                alt="banner"
              />

              {/* Overlay */}
              <div className="carousel-caption d-flex justify-content-between align-items-center w-100 text-start px-4">
                <div>
                  <h5 className="fw-bold">
                    {slide.title1} <br /> {slide.title2}
                  </h5>
                  <p className="mb-0 slider-texxt">{slide.date}</p>
                </div>

                <Button size="sm" className="buy-btn fw-semibold">
                  Buy Ticket
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BannerSlider;
